import { baseUrl } from "../airport/apis";

export const autocompleteAirportUrl = `${baseUrl}/flights/airports`;

export const searchFlightsUrl = `${baseUrl}/flights/search`;
export const flightDetailsUrl = `${baseUrl}/flight/details/`;
export const aiportCitySearchUrl = `${baseUrl}/flight/ca_search`;
